import React from 'react';
import Brochure from '../brochure';
import {BrochureItem} from '../../typing/main';
import {StyledBrochuresWrapper} from './styles';
import {UsedVehicle} from '../../typing/used-inventory';
import { useFeatureAppConfig } from '../../hooks/use-feature-app-config';

interface BrochuresProps {
  readonly brochuresData?: BrochureItem[];
  readonly vehicleData?: UsedVehicle;
}

const Brochures: React.FC<BrochuresProps> = (props) => {
  const {brochuresData, vehicleData} = props;
  const {faHostServerUrl = ""} = useFeatureAppConfig();
  return (
    <StyledBrochuresWrapper>
      {brochuresData?.map((brochure, index) => {
        return (
          <Brochure
            key={index}
            text={brochure.text}
            url={faHostServerUrl+brochure.url}
            vehicleData={vehicleData}
          />
        );
      })}
    </StyledBrochuresWrapper>
  );
};

export default Brochures;
